'use strict';

const Breakpoints = {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    XLARGE: "xlarge",
    XXLARGE: "xxlarge",
}

class Utils {
    /**
     * Check for mobile functions
     */
    static isMobile() {
        return Utils.isAndroid() || Utils.isBlackBerry() || Utils.isIOS() || Utils.isOperaMobile() || Utils.isWindowsMobile();
    }

    static isAndroid() {
        return navigator.userAgent.match(/Android/i);
    }

    static isBlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    }

    static isIOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }

    // Detects iPadOS 13+ devices that no longer expose "iPad" in the user agent.
    static isIOSDevice() {
        return (
            /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
        );
    }

    static getIOSVersion() {
        const agent = window.navigator.userAgent,
              start = agent.indexOf('OS');

        if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
            return window.Number(agent.substr(start + 3, 3).replace('_', '.'));
        }

        return 0;
    }

    static isOperaMobile() {
        return navigator.userAgent.match(/Opera Mini/i);
    }

    static isWindowsMobile() {
        return navigator.userAgent.match(/IEMobile/i);
    }

    /**
     * Check for browser
     */
    static isSafari() {
        return navigator.userAgent.match(/Safari/i) && navigator.vendor.match(/Apple Computer/i);
    }

    static isIE() {
        return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    }

    static isEdge() {
        return navigator.userAgent.match(/Edge/i);
    }

    static isChrome() {
        return navigator.userAgent.match(/Chrome/i) && navigator.vendor.match(/Google Inc/i);
    }

    static isChromium() {
        return navigator.userAgent.match(/Chrom(e|ium)/i);
    }

    /**
     * Document scroll position
     */
    static getDocumentScrollTop() {
        const body = document.body;
        const docEl = document.documentElement;
        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

        return scrollTop;
    }

    static setDocumentScrollTop(top) {
        if (window.pageYOffset) {
            window.pageYOffset = top;
        } else if(document.documentElement.scrollTop) {
            document.documentElement.scrollTop = top;
        } else{
            document.body.scrollTop = top;
        }
    }
}

Utils.Breakpoints = Breakpoints
/**
 * Check breakpoint
 *
 * @param {String} bp - 'small', 'medium', 'large', 'xlarge', 'xxlarge'
 * @return {Boolean}
 */
Utils.breakpoint = {
    match: function (bp) {
        switch (bp) {
            case Breakpoints.SMALL:
                // 0
                return window.matchMedia('(min-width: 0px)').matches;
            case Breakpoints.MEDIUM:
                // 320px width + 16px left/right padding
                return window.matchMedia('(min-width: 336px)').matches;
            case Breakpoints.LARGE:
                // 720px width + 32px left/right padding
                return window.matchMedia('(min-width: 752px)').matches;
            case Breakpoints.XLARGE:
                // 960px width + 32px left/right padding
                return window.matchMedia('(min-width: 992px)').matches;
            case Breakpoints.XXLARGE:
                // 1260px width - 32px left/right padding
                return window.matchMedia('(min-width: 1228px)').matches;
        }
    }
};

export { Utils as default };